/**
 * @desc 查询铁质材料需求周计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/web/plan/week/queryPlanFerrousMaterial',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryPlanFerrousMaterial',
    data,
  });
}
